module.exports = __webpack_public_path__ + "img/1.91bbb413.png";